import React from 'react';
import './Hero.css';
import { scrollToSection } from '../Header/Header';

const Hero: React.FC = () => {
  return (
    
    <section className='hero-container'>
      <section className="hero">
        <div className="hero-overlay">
          <div className="hero-text">
            <h1>Neksio Land:
            <br /> 
            Cereale, îngrășăminte chimice, agregate, transport cereale și mărfuri generale.
            </h1>
            <button className="main-button" onClick={() => scrollToSection('.contact-form-container')}>Solicită o ofertă</button>
          </div>
          <div className="hero-arrows">
            <div className="hero-arrow hero-arrow--gold"></div>
            <div className="hero-arrow hero-arrow--blue"></div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Hero;
